import script from "./EmailTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./EmailTemplate.vue?vue&type=style&index=0&id=3da8f739&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da8f739"]])

export default __exports__